export enum ButtonType {
  Primary = 'primary',
  PrimaryInverse = 'primary-inverse',
  Secondary = 'secondary',
  Danger = 'danger',
  PrimaryInverseWhite = 'primary-inverse-white',
  Transparent = 'transparent'
}
